module.exports = __webpack_public_path__ + "static/media/menu-4.1980d420.png";